



































import Vue from "vue"
import LoginHeader from "@/components/header/LoginHeader.vue"
import { minLength, required, sameAs } from "vuelidate/lib/validators"

export default Vue.extend({
  components: { LoginHeader },
  data() {
    return {
      request: {
        password: null,
        repeatPassword: null
      },
      jwt: "",
      errorMessage: ""
    }
  },
  validations: {
    request: {
      password: {
        required,
        minLength: minLength(8)
      },
      repeatPassword: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    submit() {
      const vm = this
      if (!vm.$v.$invalid) {
        vm.startLoad()
        vm.$http
          .post("/login/new",
            { password: vm.request.password },
            {
              headers: {
                "Authorization": "Bearer " + this.jwt
              }
            })
          .then(() => {
            vm.endLoad()
            vm.$router.push("/login")
          })
          .catch(e => {
            vm.errorMessage = e.message
            vm.endLoad()
          })
      }
    },
    getValidator(field: string, validation: string) {
      const vm = this
      return (rule: any, value: any, callback: any) => {
        if ((vm.$v.request as any)[field].$dirty && !(vm.$v.request as any)[field][validation]) {
          callback(new Error(this.$t(`login.validation.${field}.${validation}`).toString()))
        } else {
          callback()
        }
      }
    }
  },
  computed: {
    rules(): any {
      return {
        password: [{ validator: this.getValidator("password", "required"), trigger: "change" },
          { validator: this.getValidator("password", "minLength"), trigger: "change" }],
        repeatPassword: [{ validator: this.getValidator("repeatPassword", "sameAsPassword"), trigger: "change" }]
      }
    }
  },
  mounted(): void {
    this.jwt = this.$route.query.t as string
  }
})
